/* eslint-disable no-unused-vars */
import React from 'react';
import { createContext, useReducer } from 'react';
import { AppState } from '../model';
import reducer from './reducers';

// Use null as default — the Provider always supplies the real AppState.
// Calling new AppState() here would create an orphaned Pusher connection
// at module-load time that is never cleaned up.
export const Context = createContext(null);

export const Provider = ({ children, initialState }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  state.dispatch = dispatch;

  return (
    <Context.Provider value={state}>
      { children }
    </Context.Provider>
  );
};
